import classNames from "classnames";
import AppContext from "context/Context";
import PropTypes from "prop-types";
import React, { useContext, useState } from "react";
import { Collapse, Nav } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import NavbarVerticalMenuItem from "./NavbarVerticalMenuItem";
import { FaLock } from "react-icons/fa";
import ToolTip from "components/Widgets/ToolTip";

const disabledStyle = {
  // pointerEvents: "none",
  opacity: 0.5,
  cursor: "not-allowed",
  textDecoration: "none",
  color: "#6c757d",
  display: "flex",
  alignItems: "center",
  gap: "0.4rem",
};

const CollapseItems = ({ route }) => {
  const { pathname } = useLocation();

  const openCollapse = (children) =>
    children.some(
      (child) =>
        child.to === pathname ||
        (child.children && openCollapse(child.children))
    );

  const [open, setOpen] = useState(openCollapse(route.children));

  return (
    <Nav.Item as="li">
      <Nav.Link
        onClick={() => !route.disabled && setOpen(!open)}
        style={route.disabled ? disabledStyle : {}}
        className={classNames(`dropdown-indicator cursor-pointer`)}
        aria-expanded={open}
      >
        <NavbarVerticalMenuItem route={route} />
      </Nav.Link>
      <Collapse in={open}>
        <Nav className={`flex-column nav`} as="ul">
          <NavbarVerticalMenu routes={route.children} />
        </Nav>
      </Collapse>
    </Nav.Item>
  );
};

CollapseItems.propTypes = {
  route: PropTypes.shape({
    name: PropTypes.string.isRequired,
    icon: PropTypes.string,
    children: PropTypes.array.isRequired,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
  }).isRequired,
};

const NavbarVerticalMenu = ({ routes }) => {
  const {
    config: { showBurgerMenu },
    setConfig,
  } = useContext(AppContext);

  const handleNavItemClick = (route) => {
    if (showBurgerMenu && !route.disabled) {
      setConfig("showBurgerMenu", !showBurgerMenu); // Close burger menu if route is not disabled
    }
  };

  return routes.map((route) => {
    if (!route.children) {
      return (
        <Nav.Item
          as="li"
          key={route.name}
          onClick={() => handleNavItemClick(route)}
        >
          {route.disabled ? (
            // Disabled route (non-clickable span)
            <span
              style={disabledStyle}
              className="nav-link"
              data-tooltip-id="disabledRoute"
            >
              <NavbarVerticalMenuItem route={route} />
              <FaLock
                style={{
                  opacity: 0.5,
                  color: "#6c757d",
                  height: "12px",
                }}
              />
            </span>
          ) : (
            // Active/Default route (clickable NavLink)
            <NavLink
              end={route.exact}
              to={route.to}
              state={{ open: route.to === "/authentication-modal" }}
              // style={({ isActive }) =>
              //   isActive && route.to !== "#!"
              //     ? activeLinkStyle
              //     : defaultLinkStyle
              // }
              className="nav-link"
            >
              <NavbarVerticalMenuItem route={route} />
            </NavLink>
          )}
          <ToolTip
            id="disabledRoute"
            content="You do not have permission to access this screen"
          />
        </Nav.Item>
      );
    }

    return <CollapseItems route={route} key={route.name} />;
  });
};

NavbarVerticalMenu.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      icon: PropTypes.string,
      to: PropTypes.string,
      active: PropTypes.bool,
      disabled: PropTypes.bool,
      children: PropTypes.array,
    })
  ).isRequired,
};

export default NavbarVerticalMenu;
